<template>
    <div class="form">
        <ValidationObserver ref="form">
            <h2 class="profile__title">Bank account</h2>
            <div class="row mb-3">
                <ValidationProvider
                    class="col-md-6"
                    name="Bank Name"
                    v-slot="{ errors }"
                    rules="required|min:3"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Bank Name*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="bankInfo.bank_name"
                        >
                        <FormError :error="errors[0]" name="Bank Name"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Account Type"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Account Type*</label>
                        <select class="custom-select pl-4" v-model="bankInfo.account_type">
                            <option value="checking">Checking</option>
                            <option value="saving">Savings</option>
                        </select>
                        <FormError :error="errors[0]" name="Account Type"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Currency Type"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Currency Type desired for deposit*</label>
                        <select class="custom-select pl-4"  v-model="bankInfo.currency">
                            <option
                                v-for="currency in currencyList"
                                :key="currency.id"
                            >
                                {{currency.name}}
                            </option>
                        </select>
                        <small class="form-txt">*for non-USA Bank Accounts that require International Wire
                            Payments</small>
                        <FormError :error="errors[0]" name="Currency Type"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Account #"
                    v-slot="{ errors }"
                    rules="required|min:6"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Account # (or IBAN # if non-USA account)*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="bankInfo.account_number"
                        >
                        <FormError :error="errors[0]" name="Account #"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-12"
                    name="Bank ABA/SWIFT"
                    v-slot="{ errors }"
                    rules="required|min:8"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Bank ABA (Routing) # OR BIC/SWIFT/CHIPS Account # (If bank is
                            outside of USA)*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="bankInfo.bank_routing"
                        >
                        <small class="form-txt">*ABA Routing numbers are numeric. BIC/SWIFT/CHIPS numbers are
                            alpha-numeric.
                        </small>
                        <FormError :error="errors[0]" name="Bank ABA/SWIFTy"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Name on Account"
                    v-slot="{ errors }"
                    rules="required|min:1"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Name on Account (exactly as it appears)*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="bankInfo.name_on_account"
                        >
                        <FormError :error="errors[0]" name="Name on Account"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Address"
                    v-slot="{ errors }"
                    rules="required|min:4"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Address associated for this specific bank account*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="bankInfo.address_associated"
                        >
                        <small class="form-txt">If same as mailing address above, please enter “Same as Above.”</small>
                        <FormError :error="errors[0]" name="Address"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-12"
                    name="Tax ID #"
                    v-slot="{ errors }"
                    rules="min:8"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Tax ID # (USA accounts only)</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="bankInfo.tax_id"
                        >
                        <small class="form-txt">*A 1099-NEC form sent annually to IRS reporting all payments to this Tax
                            ID #.  If this is not your personal or company account, please let us know.</small>
                        <FormError :error="errors[0]" name="Tax ID #"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-12"
                    name="INTERMEDIARY BAN"
                    v-slot="{ errors }"
                    rules="required|min:8"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">INTERMEDIARY BANK (if required) ABA (Routing) # OR
                            BIC/SWIFT/CHIPS Account # (If bank is outside of USA)*</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="bankInfo.intermediary_bank"
                        >
                        <small class="form-txt">*ABA Routing numbers are numeric. BIC/SWIFT/CHIPS numbers are
                            alpha-numeric.</small>
                        <FormError :error="errors[0]" name="INTERMEDIARY BAN"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="Sort Code"
                    v-slot="{ errors }"
                    rules="min:2"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">Sort Code (UK only)</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="bankInfo.sort_code"
                        >
                        <FormError :error="errors[0]" name="Sort Code"/>
                    </div>
                </ValidationProvider>

                <ValidationProvider
                    class="col-md-6"
                    name="IRC"
                    v-slot="{ errors }"
                    rules="min:1"
                >
                    <div class="form-group mb-3">
                        <label for="" class="form-label">International Routing Code (IRC)</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="bankInfo.irc"
                        >
                        <small class="form-txt">*if your country requires this</small>
                        <FormError :error="errors[0]" name="IRC"/>
                    </div>
                </ValidationProvider>
            </div>

            <h3 class="profile__ttl">W-9 Form (for USA citizens or taxpayers only)*</h3>
            <FileContainer
                :field="`w_9_form`"
                :file-info="bankInfo.w_9_form"
                :user-id="artistId"
                @upload-file="uploadFile"
            />

            <ValidationProvider
                class="form-group"
                name="Terms and Conditions"
                v-slot="{ errors }"
                rules="required"
            >
                <label class="form-check">
                    <input
                        type="checkbox"
                        class="form-check-input-checkbox"
                        v-model="bankInfo.terms_and_condition"
                    >
                    <span class="form-check-label">
                        I agree to
                        <a
                            href="javascript:void(0)"
                            class="color_primary"
                            @click="showCustomModal('terms', 1)"
                        >
                            Terms and Conditions.
                        </a>
                        <TermsAndConditions
                            :modal-id="getCustomModalId('terms', 1)"
                        />
                    </span>
                    <FormError :error="errors[0]" name="Terms and Conditions"/>
                </label>
            </ValidationProvider>

            <BaseButtons
                v-if="isPermission"
                :on-cancel="reloadPage"
                :on-save="validate"
            />

        </ValidationObserver>
    </div>

</template>

<script>
import FileContainer from "../Common/FileContainer.vue";
import BaseButtons from "../Common/BaseButtons.vue";
import ModalHandler from "../../mixins/ModalHandler";
import FormError from "../Common/FormError.vue";
import {mapActions, mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import TermsAndConditions from "../Common/TermsAndConditions.vue";
import ArtistService from "../../services/ArtistService";

export default {
    name: 'ArtistBankInformation',
    mixins: [ModalHandler],
    components: {TermsAndConditions, FormError, BaseButtons, FileContainer},
    props: {
        adminType: String
    },
    methods: {
        ...mapActions(useArtistStore,{
            getCurrencyList: 'getCurrencyList'
        }),

        async validate() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }
            await this.updateBankInformation()
        },

        uploadFile(file) {
            this.bankInfo.w_9_form = file
        },
        async updateBankInformation() {
            try {
                const bankInfoToSend = { ...this.bankInfo };

                if (bankInfoToSend.w_9_form) {
                    bankInfoToSend.w_9_form = bankInfoToSend.w_9_form.id;
                }
                await ArtistService.updateArtistBankInfo(this.artistId, bankInfoToSend)
                this.$showSuccessMessage('Profile was successfully updated')
            } catch (error) {
                this.$showErrorMessage('The profile has not been updated')
            }
        },
    },

    watch: {
        bankInfo: {
            handler(state) {
                this.dispatchState(state);
            },
            deep: true
        }
    },

    computed: {
        ...mapState(useArtistStore, {
            bankInfo: 'bankInfo',
            artistId: 'artistId',
            currencyList: 'currencyList'
        }),
        isPermission() {
            return this.adminType !== 'agent'
        },
    },
    created() {
        this.getCurrencyList()
    }

}

</script>


<style scoped>

</style>
